import { render, staticRenderFns } from "./account-languages.vue?vue&type=template&id=2b9a1be5&scoped=true&"
import script from "./account-languages.vue?vue&type=script&lang=js&"
export * from "./account-languages.vue?vue&type=script&lang=js&"
import style0 from "./account-languages.vue?vue&type=style&index=0&id=2b9a1be5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9a1be5",
  null
  
)

export default component.exports